<div *ngIf="(user$ | async)" class="toolbar-whereapp">
    <mat-card id="logo-card">
        <mat-card-header fxLayout="row" fxLayoutGap="0" class="mb-3 mt-1">
            <div mat-card-avatar fxLayout="column" fxFlex="95px">
                <img fxFlex="50px" style="margin-top: 4px;width: 55px;" src="../../../assets/img/Clamor.jpg"
                    alt="">
                <!-- <img fxFlex="50px" src="../../../assets/icons/logohd.svg" alt=""> CUSTOMIZATION-SOLE24ORE -->
            </div>
            <div fxLayout="column">
                <mat-card-title fxFlexOffset="3px">Clamor</mat-card-title>
                <!-- <mat-card-title fxFlexOffset="3px">Il Sole 24 ORE</mat-card-title> CUSTOMIZATION-SOLE24ORE -->
                <mat-card-subtitle *ngIf="!(isUserAdmin$ | async)">{{'Multilang.loginSubtitle' | translate}}
                </mat-card-subtitle>
                <mat-card-subtitle *ngIf="(isUserAdmin$ | async)">Portale amministrativo</mat-card-subtitle>
            </div>

        </mat-card-header>
    </mat-card>


    <div id="info-container">
        <button [matMenuTriggerFor]="menu" id="menu-button">
            <mat-icon aria-hidden="false">menu</mat-icon>
        </button>
        <!-- Pagina Contatti -->
        <div *ngIf="!(isUserAdmin$ | async)" id="contacts-button">
            <a routerLink="/contacts">
                <mat-icon [inline]="true">perm_phone_msg</mat-icon>
            </a>
        </div>
        <mat-menu #menu="matMenu" xPosition="before">
            <span></span>
            <div id="menu-user-info">
                <span class="menu-version-info-line"><small>Ver. {{version}}</small></span>
                <span class="menu-user-info-line" id="user-line">
                    <small *ngIf="!(isUserAdmin$ | async)">Operatore: </small>
                    <small *ngIf="(isUserAdmin$ | async)">Amministratore: </small>
                    {{ username$ | async }}</span>
            </div>
            <button mat-menu-item routerLink="/messages">Messaggi</button>
            <button *ngIf="!(isUserAdmin$ | async)" mat-menu-item routerLink="/distribution-list">Liste di
                distribuzione</button>
            <button *ngIf="isUserAdmin$ | async" mat-menu-item routerLink="/users">Operatori</button>
            <button *ngIf="isUserAdmin$ | async" mat-menu-item routerLink="/clients">Mittenti</button>
            <button *ngIf="isUserAdmin$ | async" mat-menu-item routerLink="/areas">Aree</button>
            <button *ngIf="isUserAdmin$ | async" mat-menu-item routerLink="/services">Servizi</button>
            <button *ngIf="isUserAdmin$ | async" mat-menu-item routerLink="/dboard">Dashboard</button>
            <button mat-menu-item routerLink="/change-password">Modifica della password</button>
            <button mat-menu-item (click)="logout()">Logout</button>
        </mat-menu>
    </div>
</div>

<router-outlet></router-outlet>
<div fxLayoutAlign="center" style="color: grey; margin-top: 16px">
    <span></span>
</div>
